import { render, staticRenderFns } from "./MarkdownArticle.vue?vue&type=template&id=193c10bc&lang=pug&"
import script from "./MarkdownArticle.vue?vue&type=script&lang=js&"
export * from "./MarkdownArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports